import * as React from "react";

import { PagerContainer as Pager } from "../../../../FormParts/Pager/PagerContainer";
import { AddRowButtonContainer as AddRowButton } from "../../../AddRowButton/AddRowButtonContainer";
import { Sticky } from "../../../Sticky/Sticky";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { useCandyTheme } from "../../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { useTypedSelector } from "../../../../../../../Common/UseTypedSelector";

import { AddButtonContainer, AlignSpacer, Content, PagerContainer, Root } from "./Footer.styles";

export interface FooterProps {
    bindingPath: AbsoluteModelPath;
    horizontalScroll: number;
    isLastRow: boolean;
    setRefSticky: (x: null | Sticky) => void;
    buttonText?: string;
    maxOccurs?: number;
    width: number;
    isPager: boolean;
    isAddButton: boolean;
    filteredUniqKey: string;
}

export function Footer(props: FooterProps): JSX.Element {
    const theme = useCandyTheme();
    const isReadOnly = useTypedSelector(state => state.settings.isReadOnly);

    return (
        <Root>
            <Sticky
                background={theme.keyPalette.primaryBackgroundColor}
                allWidth
                horizontalScroll={props.horizontalScroll}
                isLastRow={props.isLastRow}
                ref={props.setRefSticky}
                width={props.width}>
                <Content>
                    <AlignSpacer />
                    {!isReadOnly && props.isAddButton && (
                        <AddButtonContainer>
                            <AddRowButton
                                bindingPath={props.bindingPath}
                                text={props.buttonText}
                                maxOccurs={props.maxOccurs}
                                filteredUniqKey={props.filteredUniqKey}
                            />
                        </AddButtonContainer>
                    )}
                    {props.isPager && (
                        <PagerContainer>
                            <Pager bindingPath={props.bindingPath} filteredUniqKey={props.filteredUniqKey} />
                        </PagerContainer>
                    )}
                </Content>
            </Sticky>
        </Root>
    );
}
